import './index.css';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import App from './App';
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { createAppQueryClient } from './lib/query-client';
import { setupAxiosInterceptors } from './lib/setup-axios-interceptors';
import { useAuthStore } from './stores/auth-store';
import { useFestivalWorkspaceStore } from './stores/festival-workspace-store';
import { AuthHydrationGate } from './components/session/AuthHydrationGate';
import { SessionBootstrap } from './components/session/SessionBootstrap';

library.add(far, fas, fab);

const basename = import.meta.env.BASE_URL.replace(/\/$/, '');
const history = createBrowserHistory({ basename });

const queryClient = createAppQueryClient();

setupAxiosInterceptors({
  queryClient,
  onUnauthorized: () => {
    useAuthStore.getState().clearSession();
    useFestivalWorkspaceStore.getState().clearFestivalWorkspace();
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element');
}
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <Router history={history}>
      <AuthHydrationGate>
        <SessionBootstrap />
        <App />
      </AuthHydrationGate>
    </Router>
  </QueryClientProvider>,
);
